import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import lottie, { AnimationItem } from 'lottie-web';

@Component({
  selector: 'app-search-no-results',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './search-no-results.component.html',
  styleUrl: './search-no-results.component.scss',
})
export class SearchNoResultsComponent implements AfterViewInit, OnDestroy {
  @Input() query = '';
  @Input() showAskAssistant = true;

  @Output() requestArtefact = new EventEmitter<void>();
  @Output() fullTextSearch = new EventEmitter<void>();
  @Output() askAssistant = new EventEmitter<string>();

  @ViewChild('lottieContainer') lottieContainer!: ElementRef<HTMLDivElement>;

  private animation: AnimationItem | null = null;

  ngAfterViewInit(): void {
    if (this.lottieContainer?.nativeElement) {
      this.animation = lottie.loadAnimation({
        container: this.lottieContainer.nativeElement,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'animations/astronaut-no-results.json',
      });
    }
  }

  ngOnDestroy(): void {
    this.animation?.destroy();
    this.animation = null;
  }
}
